import { Select, Stack, Text } from '@mantine/core'
import { useClientContext } from '@/hooks/useClientContext'
import { usePermissions } from '@/hooks/usePermissions'

export function ClientSwitcher() {
  const {
    clients,
    isLoadingClients,
    showClientSwitcher,
    selectedClientId,
    setSelectedClientId,
  } = useClientContext()
  const { tenantId, clientName, canAccessAllClients } = usePermissions()

  if (!showClientSwitcher) return null

  const getTenantLabel = (tenant: { tenant_id: string; tenant_name: string | null }) => {
    if (tenant.tenant_name?.trim()) return tenant.tenant_name.trim()
    if (clientName && tenantId && tenant.tenant_id === tenantId) return clientName
    return tenant.tenant_id
  }

  const options = [
    ...(canAccessAllClients ? [{ value: '', label: 'Portfolio View' }] : []),
    ...clients.map(client => ({
      value: client.tenant_id,
      label: getTenantLabel(client),
    })),
  ]

  return (
    <Stack gap={4} px="sm" mb="sm">
      <Text size="xs" fw={600} c="dimmed" tt="uppercase">
        Tenant
      </Text>
      <Select
        size="xs"
        placeholder={canAccessAllClients ? 'Portfolio View' : 'Select tenant'}
        data={options}
        value={selectedClientId ?? ''}
        onChange={value => setSelectedClientId(value || null)}
        searchable
        clearable
        disabled={isLoadingClients}
      />
    </Stack>
  )
}
